<template>
      <div class="row justify-content-space-between">
        <div class="col-12">
          <div class="dashboard-date-filter">
            <strong style="align-self: center; white-space: nowrap;">Выбрать дату:</strong>
            <input type="date" v-model="startDate" @change="updateDateRange" />
            <input type="date" v-model="endDate" @change="updateDateRange" />
          </div>
          <div style="margin-top: 12px;">
            <strong style="margin-right: 8px;">Год:</strong>
            <button class="btn-tab right-space-16" @click="setYear(['Sun Jan 01 2022 00:00:00', 'Sun Dec 31 2022 00:00:00'])">2022</button>
            <button class="btn-tab right-space-16" @click="setYear(['Sun Jan 01 2023 00:00:00', 'Sun Dec 31 2023 00:00:00'])">2023</button>
            <button class="btn-tab right-space-16" @click="setYear(['Sun Jan 01 2024 00:00:00', 'Sun Dec 31 2024 00:00:00'])">2024</button>
            <button class="btn-tab right-space-16" @click="setYear(['Sun Jan 01 2025 00:00:00', 'Sun Dec 31 2025 00:00:00'])">2025</button>
            <button class="btn-tab right-space-16" @click="setYear(['Sun Jan 01 2022 00:00:00', 'Sun Dec 31 2025 00:00:00'])">Всё время</button>
          </div>
        </div>
        <strong class="col-12" style="margin-top: 12px;" v-if="this.startDate && this.endDate">Период c {{ format_date(this.startDate) }} по {{ format_date(this.endDate) }}</strong>
      </div>
  <div class="row">

    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Инспекции автопарка</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'Безопасность автотранспорта'"
          :first_answer_result="'Нет'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Документарное соответствие (ОТиТБ) v2.0 (2023)</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'Документация по ОТ v 2.0 (2023)'"
          :first_answer_result="'Нет'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Коэффициент аварийности</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'ДТП'"
          :first_answer_result="'Да'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Соответствие матбазы</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'Соответствие матбазы'"
          :first_answer_result="'Да'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Кол-во НС / серьезных аварий</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'НС и серьёзные аварии'"
          :first_answer_result="'Да'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Документарное соответствие (ОТиТБ) v1.0 (2022)</strong>
      </div>
      <div class="col-12">
        <ProgressBar :uploadPercentage = uploadPercentage v-if = "uploadPercentage===Infinity"></ProgressBar>
        <DashChart v-else
          :companies_names="GetCompaniesNames"
          :results="resultQuery"
          :report_title="'Документация по ОТ v 1.0 (2022)'"
          :first_answer_result="'нет'"
          :second_answer_result="''">
        </DashChart>
      </div>
    </div>
  </div>
</template>

<script>
import DashChart from "@/components/Dashbord/DashChart.vue";
import ProgressBar from "@/components/Shared/ProgressBar.vue";
import moment from 'moment'

export default {
  components: { DashChart, ProgressBar },
  data() {
    return {
      isOnetimePassword: JSON.parse(localStorage.getItem('is_onetime_password')),
      showSearch: false,
      title: "Дашборд",
      startDate: '2022-10-01',
      endDate: moment().format('YYYY-MM-DD'),
      datefilter: ['2022-10-01', moment().format('YYYY-MM-DD')],
      search: null,
      year: '',
      FilteredChecklists: [],
      // uploadPercentage: 15,
    }
  },
  computed: {
    // Checklists() {
    //   return this.$store.state.count_checklists.filter((checklist) => checklist.finish==true)
    // },
    Checklists() {
      return this.$store.state.statistic
    },
    uploadPercentage() {
      if (!this.$store.state.statistic.length) {
        return 0; // или return 100, если 0% не подходит
      }
      return (100 / this.$store.state.statistic.length) * 100; // или другая логика
    },

    resultQuery() {

      this.countArray = []
      const byDate = (item) => {
          const itemDate = new Date(item.period);
          return (
          itemDate >= new Date(this.datefilter[0]) &&
          itemDate <= new Date(this.datefilter[1])
          );
      };

      const byTitle = (item) =>
          item.title.toLowerCase().includes(this.search.toLowerCase());

      let results = this.Checklists;

      if (this.search) {
          results = results.filter(byTitle);
      }
      const hasDateFilter =
          this.datefilter?.length >= 2 &&
          this.datefilter[0] &&
          this.datefilter[1];
      if (hasDateFilter) {
          results = results.filter(byDate);
      }

      // console.log(results)
      return results;
    },

    GetCompanies() {
      return this.$store.state.companies
    },
    GetCompaniesNames() {
      return this.GetCompanies.map(company => company.name)
    },
  },
  async created() {
        this.$store.dispatch("fetchCompanies");
        this.$store.dispatch("fetchStatistic", [moment(String(this.datefilter[0])).format('YYYY-MM-DD'), moment(String(this.datefilter[1])).format('YYYY-MM-DD')]);

  },
  methods: {
    updateDateRange() {
      if (this.startDate && this.endDate) {
        this.datefilter = [this.startDate, this.endDate];
        this.$store.dispatch("fetchStatistic", [
          moment(this.startDate).format('YYYY-MM-DD'),
          moment(this.endDate).format('YYYY-MM-DD')
        ]);
      }
    },
    setYear(year){
      this.startDate = moment(year[0]).format('YYYY-MM-DD');
      this.endDate = moment(year[1]).format('YYYY-MM-DD');
      this.datefilter = [this.startDate, this.endDate];
      this.year = year;
      this.$store.dispatch("fetchStatistic", [this.startDate, this.endDate]);
    },
    format_date(value, full = false) {
      if (!value) return '';
      const date = moment(String(value));
      if (full) {
        const jsDate = date.toDate();
        return jsDate.toDateString() + ' ' + jsDate.toTimeString().split(' ')[0];
      }
      return date.format('DD.MM.YYYY');
    },
  }
};
</script>
